import styled from "styled-components";

import {getTheme} from "../shared/themeUtils";

const Contain = styled.span`
  font-size: ${getTheme("fontSizes.xSmall")};
  font-weight: 400;
  color: ${getTheme("colors.secondaryFont")};
  padding-left: ${getTheme("space.1")};
  display: flex;
  align-items: center;
`
type PropsType = {
  price: number,
  unit: string,
  className?: string
}
const NormalizedUnitPrice = (props: PropsType) => {
  return (
    <Contain className={props.className}>
      {props.price}/{props.unit}
    </Contain>
  )
}

export default NormalizedUnitPrice